import { useMemo, useState } from "react";

function getPath(obj, path) {
  return path.split(".").reduce((value, key) => (value == null ? value : value[key]), obj);
}

export function usePagedList(items, { search = "", searchFields = [], pageSize = 8 } = {}) {
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    if (!search.trim() || searchFields.length === 0) return items;
    const query = search.trim().toLowerCase();
    return items.filter((item) =>
      searchFields.some((field) => String(getPath(item, field) ?? "").toLowerCase().includes(query))
    );
  }, [items, search, searchFields]);

  const totalItems = filtered.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safePage = Math.min(page, totalPages);
  const pageItems = filtered.slice((safePage - 1) * pageSize, safePage * pageSize);

  return { page: safePage, setPage, totalPages, totalItems, pageItems };
}
